export default "__VITE_ASSET__BV84pqPA__"